import React from 'react';

import CSSModule from 'react-css-modules';

import MiniLogo from '../../assets/images/MiniLogo.svg';
import MyCouponLogo from '../../assets/images/MyCouponLogo.svg';
import OwnABusinessCollage from '../../assets/images/OwnABusinessCollage.webp';
import styles from './SponsoredCard.module.scss';

const SPONSORED_LINK = 'https://www.mycouponbook.ca/landing/business';

// Placeholder business-owner photos for the fanned collage — swap for real
// asset URLs once available; these are just stand-ins matching the
// reference image's subject matter (tradesperson, market vendor, salon,
// barista).
const COLLAGE_PHOTOS = [
  'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=400&q=80',
  'https://images.unsplash.com/photo-1607083206968-13611e3d76db?auto=format&fit=crop&w=400&q=80',
  'https://images.unsplash.com/photo-1595475207225-428b62bda831?auto=format&fit=crop&w=400&q=80',
  'https://images.unsplash.com/photo-1509042239860-f550ce710b93?auto=format&fit=crop&w=400&q=80',
];

/**
 * Static promotional card that advertises MyCouponbook's own "list your
 * business" signup flow — NOT a real coupon. Styled to match
 * CustomerCouponCard's grid-card shape (same radius/shadow/font) so it
 * drops cleanly into the same grid, but is entirely self-contained: no
 * data prop, no favourite/follow logic, just a single external link.
 *
 * The whole card is one big link — clicking anywhere (including the
 * bottom "Learn more" bar) opens SPONSORED_LINK in a new tab.
 *
 * Rendered by Home.js at exactly one fixed position (10th card, index 8)
 * in the Newest Coupons grid — see that file for the insertion logic.
 */
const SponsoredCard = () => (
  <a
    href={SPONSORED_LINK}
    target="_blank"
    rel="noopener noreferrer"
    styleName="card"
    aria-label="Own a business? Join My Couponbook for free"
  >
    <div styleName="hero">
      <span styleName="badge">Sponsored</span>
      <img src={MyCouponLogo} alt="My Couponbook" styleName="brand-logo" />

      <img src={OwnABusinessCollage} alt="" styleName="collage-img" />

      <h3 styleName="hero-text">
        Publish a
        <br />
        <span styleName="hero-text-accent">Coupon</span>
      </h3>
    </div>

    <div styleName="body">
      <div styleName="author-row">
  <img src={MiniLogo} alt="" styleName="author-avatar" />
  <span styleName="author-name">My Couponbook</span>
</div>

      <p styleName="headline">Own a business? Join our community, Free.</p>
    </div>

    <div styleName="cta-bar">Learn more</div>
  </a>
);

export default CSSModule(SponsoredCard, styles, { allowMultiple: true });